require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./flexlayout"), require("./utils"), require("./vspacer"));
	else if(typeof define === 'function' && define.amd)
		define(["./flexlayout", "./utils", "./vspacer"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./flexlayout"), require("./utils"), require("./vspacer")) : factory(root["./flexlayout"], root["./utils"], root["./vspacer"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__77765__, __WEBPACK_EXTERNAL_MODULE__78815__, __WEBPACK_EXTERNAL_MODULE__57176__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[881],{

/***/ 70911:
/***/ ((module) => {

var amdi18n={"__root":{"confirmLabel":"Confirm password","currentLabel":"Current password","hideLabel":"Hide password","messageConfirmIsBlank":"Enter a confirmational password.","messageCurrentIsBlank":"Enter your current password.","messageNewAndConfirmDoNotMatch":"Passwords do not match.","messageNewAndConfirmMatch":"Passwords match.","messageNewAndCurrentMatch":"New password cannot match the current password.","messageNewIsBlank":"Enter a new password.","newLabel":"Password","showLabel":"Show password"},"__cs":{"confirmLabel":"Potvrdit heslo","currentLabel":"Aktuální heslo","hideLabel":"Skrýt heslo","messageConfirmIsBlank":"Zadejte potvrzující heslo.","messageCurrentIsBlank":"Zadejte vaše aktuální heslo.","messageNewAndConfirmDoNotMatch":"Hesla se neshodují.","messageNewAndConfirmMatch":"Hesla se shodují.","messageNewAndCurrentMatch":"Nové heslo nesmí být shodné s heslem aktuálním.","messageNewIsBlank":"Zadejte nové heslo.","newLabel":"Heslo","showLabel":"Zobrazit heslo"},"__da":{"confirmLabel":"Bekræft kodeord","currentLabel":"Aktuelt kodeord","hideLabel":"Skjul kodeord","messageConfirmIsBlank":"Indtast et bekræftende kodeord.","messageCurrentIsBlank":"Indtast dit nuværende kodeord.","messageNewAndConfirmDoNotMatch":"Kodeordene er ikke ens.","messageNewAndConfirmMatch":"Kodeordene er ens.","messageNewAndCurrentMatch":"Nyt kodeord kan ikke være det samme som det aktuelle.","messageNewIsBlank":"Angiv et nyt kodeord.","newLabel":"Kodeord","showLabel":"Vis kodeord"},"__de":{"confirmLabel":"Kennwort bestätigen","currentLabel":"Aktuelles Kennwort","hideLabel":"Kennwort ausblenden","messageConfirmIsBlank":"Bestätigungskennwort eingeben. ","messageCurrentIsBlank":"Aktuelles Kennwort eingeben. ","messageNewAndConfirmDoNotMatch":"Die Kennwörter stimmen nicht überein.","messageNewAndConfirmMatch":"Die Kennwörter stimmen überein.","messageNewAndCurrentMatch":"Das neue Kennwort darf nicht mit dem aktuellen Kennwort übereinstimmen. ","messageNewIsBlank":"Neues Kennwort eingeben. ","newLabel":"Kennwort","showLabel":"Kennwort anzeigen"},"__es":{"confirmLabel":"Confirmar contraseña","currentLabel":"Contraseña actual","hideLabel":"Ocultar contraseña","messageConfirmIsBlank":"Especifique una contraseña de confirmación. ","messageCurrentIsBlank":"Especifique su contraseña actual.","messageNewAndConfirmDoNotMatch":"Las contraseñas no coinciden.","messageNewAndConfirmMatch":"Las contraseñas coinciden.","messageNewAndCurrentMatch":"La nueva contraseña no puede coincidir con la contraseña actual.","messageNewIsBlank":"Especifique una nueva contraseña.","newLabel":"Contraseña","showLabel":"Mostrar contraseña"},"__fi":{"confirmLabel":"Vahvista salasana","currentLabel":"Nykyinen salasana","hideLabel":"Piilota salasana","messageConfirmIsBlank":"Anna salasanan vahvistus.","messageCurrentIsBlank":"Anna nykyinen salasanasi.","messageNewAndConfirmDoNotMatch":"Salasanat eivät täsmää.","messageNewAndConfirmMatch":"Salasanat täsmäävät.","messageNewAndCurrentMatch":"Uusi salasana ei voi olla sama kuin vanha salasana.","messageNewIsBlank":"Anna uusi salasana.","newLabel":"Salasana","showLabel":"Näytä salasana"},"__fr":{"confirmLabel":"Confirmation du mot de passe","currentLabel":"Mot de passe en cours","hideLabel":"Masquer le mot de passe","messageConfirmIsBlank":"Entrez un mot de passe de confirmation.","messageCurrentIsBlank":"Entrez votre mot de passe actuel.","messageNewAndConfirmDoNotMatch":"Les mots de passe ne concordent pas.","messageNewAndConfirmMatch":"Les mots de passe concordent.","messageNewAndCurrentMatch":"Le nouveau mot de passe ne doit pas correspondre au mot de passe en cours.","messageNewIsBlank":"Entrez un nouveau mot de passe.","newLabel":"Mot de passe","showLabel":"Afficher le mot de passe"},"__hr":{"confirmLabel":"Potvrda lozinke","currentLabel":"Trenutna lozinka","hideLabel":"Sakrij lozinku","messageConfirmIsBlank":"Unesi lozinku radi potvrde","messageCurrentIsBlank":"Unesi trenutnu lozinku","messageNewAndConfirmDoNotMatch":"Lozinke se ne podudaraju.","messageNewAndConfirmMatch":"Lozinke se podudaraju.","messageNewAndCurrentMatch":"Nova lozinka ne može se podudarati s trenutnom lozinkom.","messageNewIsBlank":"Unesi novu lozinku.","newLabel":"Lozinka","showLabel":"Pokaži lozinku"},"__hu":{"confirmLabel":"Jelszó megerősítése","currentLabel":"Aktuális jelszó","hideLabel":"Jelszó elrejtése","messageConfirmIsBlank":"Adjon meg egy megerősítő jelszót. ","messageCurrentIsBlank":"Adja meg az aktuális jelszavát. ","messageNewAndConfirmDoNotMatch":"A jelszavak nem egyeznek.","messageNewAndConfirmMatch":"A jelszavak egyeznek.","messageNewAndCurrentMatch":"Az új jelszó nem egyezhet meg az aktuális jelszóval.","messageNewIsBlank":"Adjon meg egy új jelszót. ","newLabel":"Jelszó","showLabel":"Jelszó megjelenítése"},"__it":{"confirmLabel":"Conferma password","currentLabel":"Password attuale","hideLabel":"Nascondi password","messageConfirmIsBlank":"Immettere una password di conferma. ","messageCurrentIsBlank":"Immettere la password corrente. ","messageNewAndConfirmDoNotMatch":"Le password non corrispondono.","messageNewAndConfirmMatch":"Le password corrispondono.","messageNewAndCurrentMatch":"La nuova password non può corrispondere alla password attuale.","messageNewIsBlank":"Immettere una nuova password. ","newLabel":"Password","showLabel":"Mostra password"},"__ja":{"confirmLabel":"パスワードの確認","currentLabel":"現在のパスワード","hideLabel":"パスワードを非表示にする","messageConfirmIsBlank":"確認のためにパスワードをもう一度入力してください。","messageCurrentIsBlank":"現在のパスワードを入力してください。","messageNewAndConfirmDoNotMatch":"パスワードが一致しません。","messageNewAndConfirmMatch":"パスワードが一致しました。","messageNewAndCurrentMatch":"新しいパスワードが現在のパスワードと一致しません。","messageNewIsBlank":"新規パスワードを入力してください。","newLabel":"パスワード","showLabel":"パスワードを表示"},"__kk":{"confirmLabel":"Құпия сөзді растау","currentLabel":"Ағымдағы Құпия сөз","hideLabel":"Құпия сөзді жасыру","messageConfirmIsBlank":"Растайтын құпия сөзді енгізіңіз.","messageCurrentIsBlank":"Ағымдағы құпия сөзді енгізіңіз.","messageNewAndConfirmDoNotMatch":"Құпия сөздер сәйкес емес.","messageNewAndConfirmMatch":"Сәйкес құпія сөздер.","messageNewAndCurrentMatch":"Жаңа құпия сөз қазіргі ағымдағы құпия сөзге сәйкес келмейді.","messageNewIsBlank":"Жаңа құпия сөзді енгізіңіз.","newLabel":"Құпия сөз","showLabel":"Құпия сөзді көрсету"},"__ko":{"confirmLabel":"비밀번호 확인","currentLabel":"현재 비밀번호","hideLabel":"비밀번호 숨기기","messageConfirmIsBlank":"확인 비밀번호를 입력하십시오.","messageCurrentIsBlank":"현재 비밀번호를 입력하십시오.","messageNewAndConfirmDoNotMatch":"비밀번호가 일치하지 않습니다.","messageNewAndConfirmMatch":"비밀번호가 일치합니다.","messageNewAndCurrentMatch":"새 비밀번호는 현재 비밀번호와 일치할 수 없습니다.","messageNewIsBlank":"새 비밀번호를 입력하십시오.","newLabel":"비밀번호","showLabel":"비밀번호 표시"},"__nb":{"confirmLabel":"Bekreft passord","currentLabel":"Gjeldende passord","hideLabel":"Skjul passord","messageConfirmIsBlank":"Oppgi et bekreftelsespassord.","messageCurrentIsBlank":"Oppgi ditt gjeldende passord.","messageNewAndConfirmDoNotMatch":"Passordene samsvarer ikke.","messageNewAndConfirmMatch":"Passordene samsvarer.","messageNewAndCurrentMatch":"Nytt passord kan ikke være likt gjeldende passord.","messageNewIsBlank":"Oppgi et nytt passord.","newLabel":"Passord","showLabel":"Vis passord"},"__nl":{"confirmLabel":"Wachtwoord bevestigen","currentLabel":"Huidig wachtwoord","hideLabel":"Wachtwoord verbergen","messageConfirmIsBlank":"Geef een wachtwoord ter bevestiging op.","messageCurrentIsBlank":"Geef het huidige wachtwoord op.","messageNewAndConfirmDoNotMatch":"De wachtwoorden zijn niet gelijk.\n","messageNewAndConfirmMatch":"De wachtwoorden zijn gelijk.\n","messageNewAndCurrentMatch":"Nieuw wachtwoord mag niet gelijk zijn aan huidig wachtwoord.","messageNewIsBlank":"Geef een nieuw wachtwoord op.","newLabel":"Wachtwoord","showLabel":"Wachtwoord afbeelden\n"},"__no":{"confirmLabel":"Bekreft passord","currentLabel":"Gjeldende passord","hideLabel":"Skjul passord","messageConfirmIsBlank":"Oppgi et bekreftelsespassord.","messageCurrentIsBlank":"Oppgi ditt gjeldende passord.","messageNewAndConfirmDoNotMatch":"Passordene samsvarer ikke.","messageNewAndConfirmMatch":"Passordene samsvarer.","messageNewAndCurrentMatch":"Nytt passord kan ikke være likt gjeldende passord.","messageNewIsBlank":"Oppgi et nytt passord.","newLabel":"Passord","showLabel":"Vis passord"},"__pl":{"confirmLabel":"Potwierdź hasło","currentLabel":"Obecne hasło","hideLabel":"Ukryj hasło","messageConfirmIsBlank":"Wprowadź hasło potwierdzające.","messageCurrentIsBlank":"Wprowadź aktualne hasło.","messageNewAndConfirmDoNotMatch":"Hasła nie zgadzają się.","messageNewAndConfirmMatch":"Hasła zgadzają się.","messageNewAndCurrentMatch":"Nowe hasło nie może być identyczne z obecnym.","messageNewIsBlank":"Wprowadź nowe hasło.","newLabel":"Hasło","showLabel":"Pokaż hasło"},"__pt":{"confirmLabel":"Senha de Confirmação","currentLabel":"Senha Atual:","hideLabel":"Oculte a senha","messageConfirmIsBlank":"Insira uma senha de confirmação.","messageCurrentIsBlank":"Insira sua senha atual.","messageNewAndConfirmDoNotMatch":"As senhas não correspondem.","messageNewAndConfirmMatch":"As senhas correspondem.","messageNewAndCurrentMatch":"A nova senha não pode corresponder à senha atual.","messageNewIsBlank":"Digite uma nova senha.","newLabel":"Senha","showLabel":"Exiba a senha"},"__pt-br":{"confirmLabel":"Senha de Confirmação","currentLabel":"Senha Atual:","hideLabel":"Oculte a senha","messageConfirmIsBlank":"Insira uma senha de confirmação.","messageCurrentIsBlank":"Insira sua senha atual.","messageNewAndConfirmDoNotMatch":"As senhas não correspondem.","messageNewAndConfirmMatch":"As senhas correspondem.","messageNewAndCurrentMatch":"A nova senha não pode corresponder à senha atual.","messageNewIsBlank":"Digite uma nova senha.","newLabel":"Senha","showLabel":"Exiba a senha"},"__ro":{"confirmLabel":"Confirmaţi parola","currentLabel":"Parola curentă","hideLabel":"Ascundere parolă ","messageConfirmIsBlank":"Introduceţi parola de confirmare.","messageCurrentIsBlank":"Introduceţi parola curentă.","messageNewAndConfirmDoNotMatch":"Parolele nu se potrivesc.","messageNewAndConfirmMatch":"Parolele se potrivesc.","messageNewAndCurrentMatch":"Parola nouă nu poate fi identică cu parola curentă.","messageNewIsBlank":"Introduceţi o parolă nouă.","newLabel":"Parolă","showLabel":"Afişare parolă"},"__ru":{"confirmLabel":"Подтверждение пароля","currentLabel":"Текущий пароль","hideLabel":"Скрыть пароль","messageConfirmIsBlank":"Введите подтверждение пароля.","messageCurrentIsBlank":"Введите свой текущий пароль.","messageNewAndConfirmDoNotMatch":"Пароли не совпадают.","messageNewAndConfirmMatch":"Пароли совпадают.","messageNewAndCurrentMatch":"Новый пароль не должен совпадать с текущим паролем.","messageNewIsBlank":"Введите новый пароль","newLabel":"Пароль","showLabel":"Показать пароль"},"__sl":{"confirmLabel":"Potrditev gesla","currentLabel":"Trenutno geslo","hideLabel":"Skrij geslo","messageConfirmIsBlank":"Vnesite potrditveno geslo. ","messageCurrentIsBlank":"Vnesite trenutno geslo. ","messageNewAndConfirmDoNotMatch":"Gesli se ne ujemata.","messageNewAndConfirmMatch":"Gesli se ujemata.","messageNewAndCurrentMatch":"Novo geslo se ne sme ujemati s trenutnim geslom.","messageNewIsBlank":"Vnesite novo geslo. ","newLabel":"Geslo","showLabel":"Pokaži geslo"},"__sv":{"confirmLabel":"Bekräfta lösenord","currentLabel":"Aktuellt lösenord","hideLabel":"Dölj lösenord","messageConfirmIsBlank":"Ange ett bekräftelselösenord.","messageCurrentIsBlank":"Ange nuvarande lösenord.","messageNewAndConfirmDoNotMatch":"Lösenorden stämmer inte överens.","messageNewAndConfirmMatch":"Lösenorden stämmer.","messageNewAndCurrentMatch":"Det nya lösenordet får inte vara samma som det aktuella lösenordet.","messageNewIsBlank":"Ange en nytt lösenord.","newLabel":"Lösenord","showLabel":"Visa lösenord"},"__th":{"confirmLabel":"ยืนยันรหัสผ่าน","currentLabel":"รหัสผ่านปัจจุบัน","hideLabel":"ซ่อนรหัสผ่าน","messageConfirmIsBlank":"ป้อนรหัสผ่านที่ต้องการยืนยัน","messageCurrentIsBlank":"ป้อนรหัสผ่านปัจจุบันของคุณ","messageNewAndConfirmDoNotMatch":"รหัสผ่านไม่ตรง","messageNewAndConfirmMatch":"รหัสผ่านตรงกัน","messageNewAndCurrentMatch":"รหัสผ่านใหม่ไม่ตรงกับรหัสผ่านปัจจุบัน","messageNewIsBlank":"ป้อนรหัสผ่านใหม่","newLabel":"รหัสผ่าน","showLabel":"แสดงรหัสผ่าน"},"__tr":{"confirmLabel":"Parolayı onayla","currentLabel":"Geçerli parola","hideLabel":"Parolayı gizle","messageConfirmIsBlank":"Doğrulayıcı bir parola girin.","messageCurrentIsBlank":"Geçerli parolanızı girin.","messageNewAndConfirmDoNotMatch":"Parolalar eşleşmiyor.","messageNewAndConfirmMatch":"Parolalar eşleşiyor.","messageNewAndCurrentMatch":"Yeni parola geçerli parolayla eşleşemez.","messageNewIsBlank":"Yeni bir parola girin.","newLabel":"Parola","showLabel":"Parolayı göster"},"__zh":{"confirmLabel":"确认密码","currentLabel":"当前密码","hideLabel":"隐藏密码","messageConfirmIsBlank":"请输入确认密码。","messageCurrentIsBlank":"请输入您的当前密码。","messageNewAndConfirmDoNotMatch":"密码不匹配。","messageNewAndConfirmMatch":"密码匹配。","messageNewAndCurrentMatch":"新密码与当前密码不匹配。","messageNewIsBlank":"请输入新密码。","newLabel":"密码","showLabel":"显示密码"},"__zh-cn":{"confirmLabel":"确认密码","currentLabel":"当前密码","hideLabel":"隐藏密码","messageConfirmIsBlank":"请输入确认密码。","messageCurrentIsBlank":"请输入您的当前密码。","messageNewAndConfirmDoNotMatch":"密码不匹配。","messageNewAndConfirmMatch":"密码匹配。","messageNewAndCurrentMatch":"新密码与当前密码不匹配。","messageNewIsBlank":"请输入新密码。","newLabel":"密码","showLabel":"显示密码"},"__zh-hk":{"confirmLabel":"確認密碼","currentLabel":"現行密碼","hideLabel":"隱藏密碼","messageConfirmIsBlank":"輸入確認密碼。","messageCurrentIsBlank":"輸入現行密碼。","messageNewAndConfirmDoNotMatch":"密碼不符。","messageNewAndConfirmMatch":"密碼相符。","messageNewAndCurrentMatch":"新密碼無法與現行密碼相符。","messageNewIsBlank":"輸入新密碼。","newLabel":"密碼","showLabel":"顯示密碼"},"__zh-mo":{"confirmLabel":"確認密碼","currentLabel":"現行密碼","hideLabel":"隱藏密碼","messageConfirmIsBlank":"輸入確認密碼。","messageCurrentIsBlank":"輸入現行密碼。","messageNewAndConfirmDoNotMatch":"密碼不符。","messageNewAndConfirmMatch":"密碼相符。","messageNewAndCurrentMatch":"新密碼無法與現行密碼相符。","messageNewIsBlank":"輸入新密碼。","newLabel":"密碼","showLabel":"顯示密碼"},"__zh-sg":{"confirmLabel":"确认密码","currentLabel":"当前密码","hideLabel":"隐藏密码","messageConfirmIsBlank":"请输入确认密码。","messageCurrentIsBlank":"请输入您的当前密码。","messageNewAndConfirmDoNotMatch":"密码不匹配。","messageNewAndConfirmMatch":"密码匹配。","messageNewAndCurrentMatch":"新密码与当前密码不匹配。","messageNewIsBlank":"请输入新密码。","newLabel":"密码","showLabel":"显示密码"},"__zh-tw":{"confirmLabel":"確認密碼","currentLabel":"現行密碼","hideLabel":"隱藏密碼","messageConfirmIsBlank":"輸入確認密碼。","messageCurrentIsBlank":"輸入現行密碼。","messageNewAndConfirmDoNotMatch":"密碼不符。","messageNewAndConfirmMatch":"密碼相符。","messageNewAndCurrentMatch":"新密碼無法與現行密碼相符。","messageNewIsBlank":"輸入新密碼。","newLabel":"密碼","showLabel":"顯示密碼"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 20393:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _baUiCarbon = __webpack_require__(6536);
var _vspacer = _interopRequireDefault(__webpack_require__(57176));
var _flexlayout = _interopRequireDefault(__webpack_require__(77765));
var _utils = __webpack_require__(78815);
var _StringResource = _interopRequireDefault(__webpack_require__(76044));
var _Password = _interopRequireDefault(__webpack_require__(32129));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const {
  BaPropTypes
} = _utils.propsUtils;
const pwdClassName = _Password.default.pwdClassName.replace(/"/g, '');
class Password extends _react.Component {
  constructor(props) {
    var _props$currentPasswor, _props$newPasswordPro, _props$confirmPasswor;
    super(props);
    (0, _defineProperty2.default)(this, "_onChangeCurrentPassword", event => {
      const {
        currentPasswordProps: {
          onChange
        }
      } = this.props;
      this.setState({
        currentPassword: event.currentTarget.value
      }, this._onChange);
      onChange(event);
    });
    (0, _defineProperty2.default)(this, "_onChangeNewPassword", event => {
      const {
        newPasswordProps: {
          onChange
        }
      } = this.props;
      this.setState({
        newPassword: event.currentTarget.value
      }, this._onChange);
      onChange(event);
    });
    (0, _defineProperty2.default)(this, "_onChangeConfirmPassword", event => {
      const {
        confirmPasswordProps: {
          onChange
        }
      } = this.props;
      this.setState({
        confirmPassword: event.currentTarget.value
      }, this._onChange);
      onChange(event);
    });
    (0, _defineProperty2.default)(this, "_onChange", () => this.props.onPwdChange({
      isValid: this.state.isValid,
      currentPassword: this.state.currentPassword,
      newPassword: this.state.newPassword,
      confirmPassword: this.state.confirmPassword,
      pwd: this.state.newPassword,
      // remove when deprecated prop no longer used
      currentPwd: this.state.currentPassword // remove when deprecated prop no longer used
    }));
    this.state = {
      currentPassword: (_props$currentPasswor = props.currentPasswordProps.value) != null ? _props$currentPasswor : '',
      newPassword: (_props$newPasswordPro = props.newPasswordProps.value) != null ? _props$newPasswordPro : '',
      confirmPassword: (_props$confirmPasswor = props.confirmPasswordProps.value) != null ? _props$confirmPasswor : ''
    };
  }
  componentDidUpdate(prevProps) {
    const {
      currentPasswordProps: currentPasswordPropsPrev,
      newPasswordProps: newPasswordPropsPrev,
      confirmPasswordProps: confirmPasswordPropsPrev
    } = prevProps;
    const {
      currentPasswordProps: currentPasswordPropsCurr,
      newPasswordProps: newPasswordPropsCurr,
      confirmPasswordProps: confirmPasswordPropsCurr
    } = this.props;
    if (currentPasswordPropsPrev.value !== currentPasswordPropsCurr.value) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState((state, props) => {
        var _props$currentPasswor2;
        return {
          currentPassword: (_props$currentPasswor2 = props.currentPasswordProps.value) != null ? _props$currentPasswor2 : ''
        };
      });
    }
    if (newPasswordPropsPrev.value !== newPasswordPropsCurr.value) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState((state, props) => {
        var _props$newPasswordPro2;
        return {
          newPassword: (_props$newPasswordPro2 = props.newPasswordProps.value) != null ? _props$newPasswordPro2 : ''
        };
      });
    }
    if (confirmPasswordPropsPrev.value !== confirmPasswordPropsCurr.value) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState((state, props) => {
        var _props$confirmPasswor2;
        return {
          confirmPassword: (_props$confirmPasswor2 = props.confirmPasswordProps.value) != null ? _props$confirmPasswor2 : ''
        };
      });
    }
  }
  static getDerivedStateFromProps(props, state) {
    // Needed to map until MUI-64/MUI-111 is complete
    // When MUI-64/MUI-111 is complete messageType/messageNode are passed straight down
    const currentMessageInfo = () => {
      const {
        modifyPwd,
        currentPasswordProps: {
          messageType,
          messageNode
        }
      } = props;
      const {
        currentPassword
      } = state;
      if (!modifyPwd) {
        return {};
      }
      if (messageType || messageNode) {
        return {
          messageType: messageType != null ? messageType : 'error',
          messageNode
        };
      }
      if (!currentPassword.length) {
        return {
          messageType: 'informational',
          messageNode: _StringResource.default.get('messageCurrentIsBlank')
        };
      }

      // if (someCheck) {
      //   // additional checks and messages go here
      //   // maybe add a callback for client current password validation
      // }

      return {};
    };

    // Needed to map until MUI-64/MUI-111 is complete
    // When MUI-64/MUI-111 is complete messageType/messageNode are passed straight down
    const newMessageInfo = () => {
      const {
        errorTxtPwd,
        modifyPwd,
        newPasswordProps: {
          messageType,
          messageNode
        }
      } = props;
      const {
        currentPassword,
        newPassword
      } = state;
      if (messageType || messageNode) {
        return {
          messageType: messageType != null ? messageType : 'error',
          messageNode
        };
      }
      if (errorTxtPwd) {
        return {
          messageType: 'error',
          messageNode: errorTxtPwd
        };
      }
      if (!newPassword.length) {
        return {
          messageType: 'informational',
          messageNode: _StringResource.default.get('messageNewIsBlank')
        };
      }
      if (modifyPwd) {
        if (currentPassword.length && currentPassword === newPassword) {
          return {
            messageType: 'error',
            messageNode: _StringResource.default.get('messageNewAndCurrentMatch')
          };
        }
      }

      // if (someCheck) {
      // 	// additional checks and messages go here
      // 	// maybe add a callback for client new password validation
      // }

      return {};
    };

    // Needed to map until MUI-64/MUI-111 is complete
    // When MUI-64/MUI-111 is complete messageType/messageNode are passed straight down
    const confirmMessageInfo = () => {
      const {
        errorTxtConfirm,
        successTxtConfirm,
        confirmPasswordProps: {
          messageType,
          messageNode
        }
      } = props;
      const {
        newPassword,
        confirmPassword
      } = state;
      if (messageType || messageNode) {
        return {
          messageType: messageType != null ? messageType : 'error',
          messageNode
        };
      }
      if (errorTxtConfirm) {
        return {
          messageType: 'error',
          messageNode: errorTxtConfirm
        };
      }
      if (successTxtConfirm) {
        return {
          messageType: 'success',
          messageNode: successTxtConfirm
        };
      }
      if (!confirmPassword.length) {
        return {
          messageType: 'informational',
          messageNode: _StringResource.default.get('messageConfirmIsBlank')
        };
      }
      if (newPassword !== confirmPassword) {
        return {
          messageType: 'error',
          messageNode: _StringResource.default.get('messageNewAndConfirmDoNotMatch')
        };
      }

      // if (someCheck) {
      // 	// additional checks and messages could go here
      // 	// maybe add a callback for client confirm password validation
      // }

      if (newPassword.length && newPassword === confirmPassword) {
        return {
          messageType: 'success',
          messageNode: _StringResource.default.get('messageNewAndConfirmMatch')
        };
      }
      return {};
    };
    const {
      messageType: currentMessageType,
      messageNode: currentMessageNode
    } = currentMessageInfo();
    const {
      messageType: newMessageType,
      messageNode: newMessageNode
    } = newMessageInfo();
    const {
      messageType: confirmMessageType,
      messageNode: confirmMessageNode
    } = confirmMessageInfo();
    return {
      currentMessageType,
      currentMessageNode,
      newMessageType,
      newMessageNode,
      confirmMessageType,
      confirmMessageNode,
      isValid: (currentMessageType === undefined || currentMessageType === 'success') && (newMessageType === undefined || newMessageType === 'success') && confirmMessageType === 'success'
    };
  }
  render() {
    var _this$props$labelCurr, _this$props$labelPwd, _this$props$labelConf;
    const {
      // remove these general props
      className,
      modifyPwd,
      onPwdChange,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      // remove these current password props
      currentPasswordProps,
      // remove these new password props
      newPasswordProps,
      // remove these confirm password props
      confirmPasswordProps,
      // remove these deprecated props
      errorTxtConfirm,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      errorTxtCurrent,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      errorTxtPwd,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      labelConfirm,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      labelCurrent,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      labelPwd,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      successTxtConfirm,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      // historically these have been removed; I'm not sure why
      /* eslint-disable react/prop-types */
      htmlFor,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      label,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      onClear,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      type,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      value,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      /* eslint-enable react/prop-types */
      ...other
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_flexlayout.default, {
      className: `${pwdClassName} ${className}`,
      direction: "column"
    }, modifyPwd && /*#__PURE__*/_react.default.createElement(PasswordInput, (0, _extends2.default)({}, other, currentPasswordProps, {
      value: this.state.currentPassword,
      invalid: this.state.currentMessageType === 'error' ? true : undefined,
      invalidText: this.state.currentMessageType === 'error' ? this.state.currentMessageNode : undefined,
      labelText: (_this$props$labelCurr = this.props.labelCurrent) != null ? _this$props$labelCurr : currentPasswordProps.labelText,
      onChange: this._onChangeCurrentPassword
    })), modifyPwd && /*#__PURE__*/_react.default.createElement(_vspacer.default, {
      size: 1
    }), /*#__PURE__*/_react.default.createElement(PasswordInput, (0, _extends2.default)({}, other, newPasswordProps, {
      value: this.state.newPassword,
      invalid: this.state.newMessageType === 'error' ? true : undefined,
      invalidText: this.state.newMessageType === 'error' ? this.state.newMessageNode : undefined,
      labelText: (_this$props$labelPwd = this.props.labelPwd) != null ? _this$props$labelPwd : newPasswordProps.labelText,
      onChange: this._onChangeNewPassword
    })), /*#__PURE__*/_react.default.createElement(_vspacer.default, {
      size: 1
    }), /*#__PURE__*/_react.default.createElement(PasswordInput, (0, _extends2.default)({}, other, confirmPasswordProps, {
      value: this.state.confirmPassword,
      invalid: this.state.confirmMessageType === 'error' ? true : undefined,
      invalidText: this.state.confirmMessageType === 'error' ? this.state.confirmMessageNode : undefined,
      labelText: (_this$props$labelConf = this.props.labelConfirm) != null ? _this$props$labelConf : confirmPasswordProps.labelText,
      onChange: this._onChangeConfirmPassword
    })));
  }
}
exports["default"] = Password;
(0, _defineProperty2.default)(Password, "propTypes", {
  /** className applied to the flexLayout wrapper */
  className: _propTypes.default.string,
  /** A flag indicating a if modifying and existing password */
  modifyPwd: _propTypes.default.bool,
  /** A function called when changes are made. Props = {isValid, currentPassword, newPassword, confirmPassword, pwd(deprecated), currentPwd(deprecated) }. */
  onPwdChange: _propTypes.default.func,
  /** props passed to the current password input */
  currentPasswordProps: _propTypes.default.object,
  /** props passed to the new password input */
  newPasswordProps: _propTypes.default.object,
  /** props passed to the confirm password input */
  confirmPasswordProps: _propTypes.default.object,
  /** deprecated - use currentPasswordProps.labelText */
  labelCurrent: BaPropTypes.deprecated('deprecated - use currentPasswordProps.labelText'),
  /** deprecated - use newPasswordProps.labelText */
  labelPwd: BaPropTypes.deprecated('deprecated - use newPasswordProps.labelText'),
  /** deprecated - use confirmPasswordProps.labelText */
  labelConfirm: BaPropTypes.deprecated('deprecated - use confirmPasswordProps.labelText'),
  /** deprecated - use currentPasswordProps.messageType and currentPasswordProps.messageText */
  errorTxtCurrent: BaPropTypes.deprecated('deprecated - was never used - use currentPasswordProps.messageType and currentPasswordProps.messageText'),
  /** deprecated - use newPasswordProps.messageType and newPasswordProps.messageText */
  errorTxtPwd: BaPropTypes.deprecated('deprecated - use newPasswordProps.messageType and newPasswordProps.messageText'),
  /** deprecated - use newMessageType.mssageType and newMessageText.messageText */
  errorTxtConfirm: BaPropTypes.deprecated('deprecated - use newMessageType.mssageType and newMessageText.messageText'),
  /** deprecated - use newMessageType.mssageType and newMessageText.messageText */
  successTxtConfirm: BaPropTypes.deprecated('deprecated - use newMessageType.mssageType and newMessageText.messageText')
});
(0, _defineProperty2.default)(Password, "defaultProps", {
  className: '',
  modifyPwd: false,
  onPwdChange: () => {},
  currentPasswordProps: {
    onChange: () => {},
    hidePasswordLabel: _StringResource.default.get('hideLabel'),
    labelText: _StringResource.default.get('currentLabel'),
    showPasswordLabel: _StringResource.default.get('showLabel')
  },
  newPasswordProps: {
    onChange: () => {},
    hidePasswordLabel: _StringResource.default.get('hideLabel'),
    labelText: _StringResource.default.get('newLabel'),
    showPasswordLabel: _StringResource.default.get('showLabel')
  },
  confirmPasswordProps: {
    onChange: () => {},
    hidePasswordLabel: _StringResource.default.get('hideLabel'),
    labelText: _StringResource.default.get('confirmLabel'),
    showPasswordLabel: _StringResource.default.get('showLabel')
  }
});
class PasswordInput extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `${pwdClassName}__input`
    }, /*#__PURE__*/_react.default.createElement(_baUiCarbon.PasswordInput, this.props));
  }
}

/***/ }),

/***/ 44070:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _Password = _interopRequireDefault(__webpack_require__(20393));
exports.Password = _Password.default;
exports["default"] = _Password.default;

/***/ }),

/***/ 76044:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _utils = __webpack_require__(78815);
var _PasswordResources = _interopRequireDefault(__webpack_require__(70911));
/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2020
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = exports["default"] = new _utils.StringResource(_PasswordResources.default);

/***/ }),

/***/ 51900:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"pwdClassName": "\"ba-common-password\""
};

/***/ }),

/***/ 32129:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Password_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51900);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Password_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Password_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Password_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Password_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Password_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Password_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Password_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Password_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 93379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 90569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 19216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 44589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 6536:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 68779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 98060:
/***/ ((module) => {

"use strict";
module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 77765:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__77765__;

/***/ }),

/***/ 78815:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ }),

/***/ 57176:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__57176__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(44070));
/******/ return __webpack_exports__;
/******/ }
]);
});